import {Spin} from "antd";
import React from "react";
import {useTranslation} from "react-i18next";

export interface LoadingOverlayProps {
    working: boolean
    text?: string
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = (props) => {
    const {working, text} = props;
    const {t} = useTranslation();

    return (
        <>
            {working && <Spin tip={t(text || 'common.loading')} percent={"auto"} fullscreen={true}/>}
        </>
    );
};